import { Dispatch, SetStateAction } from 'react';

import { FULL_PERCENT } from '@hooks/constants';
import { useQuery } from '@hooks/reactQuery';

import { getMoBranches } from '@api/configurationComparison';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IMoBranchesDTO, ISelectedPreset, ISubmittedPathParamsProps } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TDefaultDTO } from '@interfaces/common/defaultDTO';
import { IResponseError } from '@interfaces/errors/apiErrors';
import { IProgressBranches } from '@interfaces/import/import';

import { MO_BRANCHES } from '@constants/queryKeys';

interface IUseQueryMoBranchesProps extends TDefaultDTO, ISelectedPreset, ISubmittedPathParamsProps {
	setRefetchIntervalProgress: Dispatch<SetStateAction<false | number>>;
	tree?: Record<string, any>;
	progress?: IProgressBranches;
	onlyChanged?: boolean;
	progressId?: string;
}

export const useQueryMoBranches = (params: IUseQueryMoBranchesProps) => {
	const {
		onlyChanged,
		page,
		pageSize,
		progressId,
		searchValue,
		setRefetchIntervalProgress,
		sortDirection,
		sortFieldName,
		submittedParams,
		submittedPath,
		tree,
		progress,
	} = params || {};

	const isFullProgress = progressId === progress?.id && progress?.percentsProgress === FULL_PERCENT;

	const {
		data: branches,
		isLoading: isLoadingBranches,
		isFetching: isFetchingBranches,
	} = useQuery({
		queryKey: [
			MO_BRANCHES,
			pageSize,
			page,
			sortDirection,
			sortFieldName,
			searchValue,
			progress,
		],
		queryFn: () => getMoBranches({
			categoryPaths: submittedPath,
			dumpId: tree?.treeIds,
			onlyChanged,
			progressId,
			...submittedParams,
			pageSize,
			page,
			sortDirection,
			sortFieldName,
			searchValue,
		} as IMoBranchesDTO),
		enabled: [
			!!submittedParams?.vendor,
			!!submittedPath?.length,
			!!progressId,
			!!tree?.treeIds,
			isFullProgress,
		],
		refetchOnWindowFocus: false,
		refetchOnmount: false,
		onError: (err: IResponseError) => {
			setRefetchIntervalProgress(false);
			handleErrorFromMessage(err);
		},
	});

	return { branches, isLoadingBranches, isFetchingBranches };
};
